export enum BiointelligentLinkType {
  RNA_PART = 'RNA_PART',
  DNA_PART = 'DNA_PART',
  AMINO_ACID_PART = 'AMINO_ACID_PART',
  TRANSCRIPTION = 'TRANSCRIPTION',
  TRANSLATION = 'TRANSLATION',
}

export const LINK_TYPE_TO_COMPONENT_NAME: {[linkType in BiointelligentLinkType]: string} = {
  [BiointelligentLinkType.RNA_PART]: 'part',
  [BiointelligentLinkType.DNA_PART]: 'part',
  [BiointelligentLinkType.AMINO_ACID_PART]: 'part',
  [BiointelligentLinkType.TRANSCRIPTION]: 'transcription',
  [BiointelligentLinkType.TRANSLATION]: 'translation',
};
